/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';

import { ApprovalRequestType } from '../../../../data/types.generated';
import { Spinner } from '../../../components';
import { requestAuthToken } from './utils';

const adobeApiBaseUrlValidator = (apiBaseUrl: string): boolean => {
    if (!apiBaseUrl) {
        return false;
    }
    const regex = /^https:\/\/[\w.-]+\.(?:adobesign|echosign|documents\.adobe)\.com\//gm;
    const regexExecArray = regex.exec(apiBaseUrl);
    return regexExecArray?.length === 1;
};

export interface AuthLoginEndProps {
    code: string;
}

export const AuthLoginEnd: React.FC<AuthLoginEndProps> = (props: AuthLoginEndProps): JSX.Element => {
    const fetchAuthToken = (): void => {
        requestAuthToken(ApprovalRequestType.ESign, props.code, adobeApiBaseUrlValidator);
    };

    React.useEffect((): void => fetchAuthToken(), []);
    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};
